/* eslint-disable import/no-unresolved */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unescaped-entities */
import {useState} from 'react';
import { useTheme } from '@mui/material/styles'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Hidden from '@mui/material/Hidden'
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import { makeStyles } from 'tss-react/mui';

import Navigation from '../Navigation';
import PrivacyPolicy from './PrivacyPolicy';
import GreenButton from '../../buttons/Green';
import PhoneInput from '../../PhoneInput';
import Textarea from '../../Textarea';
import Checkbox from '../../Checkbox';
import CustomDialog from '../../CustomDialog';
import {validateObjectByMap} from '../../../shared_client_utils/formUtils';
import {clientErrorsMap} from '../../../shared_client_utils/clientUtils';
import {
  cancellationOptionText,
} from '../../../shared_client_utils/bookingUtils';
import bookingCancellationOptions from '../../../shared_configs/bookingCancellationOptions';
import OutlinedInput from '../../Input';
import CreditCardRequired from '../other_components/CreditCardRequired';
import CircularProgressWithBackdrop from '../../CircularProgressWithBackdrop';

const useStyles = makeStyles()(theme => ({
  main: {
    padding: theme.spacing(2, 2, 0, 2),
    backgroundColor: '#ffffff',
    // overflowY: 'auto',
  },
  inputBox: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  rememberMeBox: {
    marginBottom: theme.spacing(),
  },
  greyBox: {
    flexDirection: 'column',
    backgroundColor: '#F2F2F2',
    padding: theme.spacing(),
    marginBottom: theme.spacing(2),

    '&:last-of-type': {
      marginBottom: 0,
    },
  },
  greyBoxTitle: {
    fontWeight: 500,
    marginBottom: theme.spacing(1 / 2),
  },
  greyBoxAction: {
    marginTop: theme.spacing(),
    width: '100%',
  },
  privacyPolicyLink: {
    alignItems: 'center',
    width: 'auto',
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: theme.spacing(2),
  },
  textarea: {
    width: '100%',
  },
  whiteBoxArea: {
    backgroundColor: '#ffffff',
  },
  checkbox: {
    marginRight: 0,
  },
  cancellationTextBox: {
    flexDirection: 'column',
  },
}));

const FIELD_LABELS = {
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email',
  mobileNumber: 'Mobile phone',
  landlineNumber: 'Other phone (optional)'
}

const appointmentErrorsMap = {
  serviceBookingAnswer: {
    isValid: (value, {bookingQuestion, isBookingQuestionRequired}) => {
      if (!bookingQuestion || !isBookingQuestionRequired) {
        return true;
      }
      return value && value.length > 0;
    },
  },
};

const bookingOptionErrorsMap = {
  agreePrivacyPolicy: {
    isValid: (value, {privacyPolicy}) => !privacyPolicy || value,
  },
  agreeCancellationPolicy: {
    isValid: (value, {isCancellationBoxDisplay}) => {
      return !isCancellationBoxDisplay || value;
    },
  },
};

const Client = (props) => {
  const {
    classes: parentClasses,
    business,
    client,
    bookingOptions,
    handleChangeClient,
    handleChangeAppointment,
    handleChangeBookingOptions,
    appointment,
    stepsData,
    createClientForBooking,
    verifyClientCreditCard,
    createClientCreditCard,
    handleDisplayFlashMessage,
  } = props;
  const {bookingSettings, SalesSetting: { isPayWithCard, isPayWithCardForNewClient }} = business
  const {bookingQuestion, isBookingQuestionRequired} = stepsData.service;
  const theme = useTheme()
  const primaryColor = theme.palette.primary.main

  const {classes, cx} = useStyles();
  const [clientErrors, setClientErrors] = useState({});
  const [appointmentErrors, setAppointmentErrors] = useState({});
  const [bookingOptionErrors, setBookingOptionErrors] = useState({});
  const [isUnmatchedFieldDialogOpen, setIsUnmatchedFieldDialogOpen] = useState(false);
  const [unmatchedFieldName, setUnmatchedFieldName] = useState(null)
  const [unmatchedFieldValue, setUnmatchedFieldValue] = useState(null)
  const [isCreditCardRequired, setIsCreditCardRequired] = useState(false)
  const [createdClient, setCreatedClient] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [overrideUnmatchedField, setOverrideUnmatchedField] = useState(false)
  const [createNewClientIfFirstNameNotMatches, setCreateNewClientIfFirstNameNotMatches] = useState(false)
  const [isNewValueBtnDisable, setIsNewValueBtnDisable] = useState(false);

  const handleStartLoading = () => setIsLoading(true)
  const handleStopLoading = () => setIsLoading(false)

  const creditCardDialogClose = () => setIsCreditCardRequired(false)

  const setCardRequired = (key) => setIsCreditCardRequired(key)

  const [
    isPrivacyPolicyDisplayed,
    setIsPrivacyPolicyDisplayed,
  ] = useState(false);

  const handleCompliteBooking = async ({overrideUnmatchedField = false, createNewClientIfFirstNameNotMatches = false} = {}, cClient = {}) => {
    const {
      isValid: isClientValid,
      errors: clientErrors,
    } = validateObjectByMap({...client, ...cClient}, clientErrorsMap);
    const {
      isValid: isAppointmentValid,
      errors: appointmentErrors,
    } = validateObjectByMap(
      appointment,
      appointmentErrorsMap,
      stepsData.service,
    );
    const {
      isValid: isBookingOptionsValid,
      errors: bookingOptionErrors,
    } = validateObjectByMap(
      bookingOptions,
      bookingOptionErrorsMap,
      bookingSettings,
    );

    if (!isClientValid || !isAppointmentValid || !isBookingOptionsValid) {
      props.handleDisplayFlashMessage('Fill in all highlighted fields', 'error');
      setClientErrors(clientErrors);
      setAppointmentErrors(appointmentErrors);
      setBookingOptionErrors(bookingOptionErrors);
      return;
    }
    try {
      handleStartLoading()
      const { payload: newClient = {} } = await createClientForBooking(
        {
          ...{...client, ...cClient},
          overrideUnmatchedField,
          createNewClientIfFirstNameNotMatches,
          businessId: business.id
        }
      )
      setCreatedClient(newClient)
      const isRequiredCard = (isPayWithCard || newClient?.isCardRequired || (isPayWithCardForNewClient && (newClient.isNew || !newClient.isActiveClient))) && (!newClient?.ClientCards?.length || !newClient.isActiveClient);

      if (isRequiredCard) {
        setCardRequired(true);
        handleStopLoading()
        return;
      }
      await props.handleCompliteBooking({overrideUnmatchedField, createNewClientIfFirstNameNotMatches});
    } catch (err) {
      if (err.name === 'UnmatchedClientFieldError') {
        const {unmatchedField} = err.body
        const [unmatchedFieldName, unmatchedFieldValue] = Object.entries(unmatchedField)[0]
        setUnmatchedFieldName(unmatchedFieldName)
        setUnmatchedFieldValue(unmatchedFieldValue)
        setIsUnmatchedFieldDialogOpen(true)
      }
    }
    handleStopLoading()
    setIsNewValueBtnDisable(false)
  }

  const useNewValue = async () => {
    setIsNewValueBtnDisable(true)
    await handleCompliteBooking({overrideUnmatchedField: true}, client)
    setIsUnmatchedFieldDialogOpen(false)
    setOverrideUnmatchedField(true)
    setIsNewValueBtnDisable(false)
  }
  const useExistingValue = async () => {
    setIsNewValueBtnDisable(true)
    handleChangeClient(unmatchedFieldName, unmatchedFieldValue)
    if (isUnmatchedFieldDialogOpen) {
      await handleCompliteBooking({}, {...client, [unmatchedFieldName]: unmatchedFieldValue})
      setIsUnmatchedFieldDialogOpen(false)
    }
    setIsNewValueBtnDisable(false)
  }
  const useNewPerson = async () => {
    setIsNewValueBtnDisable(true)
    await handleCompliteBooking({createNewClientIfFirstNameNotMatches: true}, client)
    setIsUnmatchedFieldDialogOpen(false)
    setCreateNewClientIfFirstNameNotMatches(true)
    setIsNewValueBtnDisable(false)
  }

  const creditCardHandler = async ({paymentMethod}) => {
    handleStartLoading()

    try {
      const { firstName, lastName, email, mobileNumber, id: clientId} = createdClient;
      const {id, card = {}} = paymentMethod;
      const {brand, country, exp_month: expMonth, exp_year: expYear, funding, last4} = card

      const verifyClientCreditCardData = {
        clientId,
        name: `${firstName} ${lastName}`,
        email,
        phone: mobileNumber,
        source: paymentMethod.id,
        businessId: business.id
      }

      try {
        const {payload} = await verifyClientCreditCard(verifyClientCreditCardData)

        if (payload?.customerId) {
          const createClientCardData = {
            token: id,
            clientId,
            brand,
            customerId: payload?.customerId,
            businessId: business.id,
            country,
            expMonth,
            expYear,
            funding,
            last4,
          };
          await createClientCreditCard(createClientCardData)
          await props.handleCompliteBooking({overrideUnmatchedField, createNewClientIfFirstNameNotMatches});
        } else {
          handleStopLoading()
          handleDisplayFlashMessage(payload?.raw?.message || payload?.code, 'error')
        }
      } catch (error) {
        handleStopLoading()
        handleDisplayFlashMessage(error?.message || error?.code || error, 'error')
      }
    } catch (error) {
      handleStopLoading()
      handleDisplayFlashMessage(error?.message || error?.code || error, 'error')
    }
    setCardRequired(false)
    handleStopLoading()
  }

  return (
    <div className={parentClasses.grid}>
      <Navigation {...props} />
      <main className={cx(parentClasses.main, classes.main)}>
        <Grid container>
          <OutlinedInput
            id="firstName"
            name="firstName"
            label={FIELD_LABELS.firstName}
            value={client.firstName}
            onChange={({target}) => {
              return handleChangeClient(target.name, target.value);
            }}
            className={classes.inputBox}
            error={clientErrors.firstName}
          />

          <OutlinedInput
            id="lastName"
            name="lastName"
            label={FIELD_LABELS.lastName}
            value={client.lastName}
            onChange={({target}) => {
              return handleChangeClient(target.name, target.value);
            }}
            className={classes.inputBox}
            error={clientErrors.lastName}
          />

          <OutlinedInput
            id="email"
            name="email"
            label={FIELD_LABELS.email}
            value={client.email}
            onChange={({target}) => {
              return handleChangeClient(target.name, target.value);
            }}
            className={classes.inputBox}
            error={clientErrors.email}
          />

          <PhoneInput
            id="mobileNumber"
            label={FIELD_LABELS.mobileNumber}
            // country={countryCode}
            value={client.mobileNumber}
            onChange={value => handleChangeClient('mobileNumber', value)}
            classes={{
              root: classes.inputBox,
            }}
            error={clientErrors.mobileNumber}
          />

          <PhoneInput
            id="landlineNumber"
            label={FIELD_LABELS.landlineNumber}
            // country={countryCode}
            value={client.landlineNumber}
            onChange={value => handleChangeClient('landlineNumber', value)}
            classes={{
              root: classes.inputBox,
            }}
          />

          <Grid
            item
            className={cx(classes.inputBox, classes.rememberMeBox)}
          >
            <Checkbox
              label="Remember me"
              checked={bookingOptions.rememberMe}
              onChange={() => handleChangeBookingOptions('rememberMe')}
            />
          </Grid>

          {bookingSettings.privacyPolicy && (
            <Grid container className={classes.inputBox}>
              <Checkbox
                label={`I agree to ${business.name}`}
                checked={bookingOptions.agreePrivacyPolicy}
                onChange={() => {
                  return handleChangeBookingOptions('agreePrivacyPolicy');
                }}
                className={classes.checkbox}
                error={bookingOptionErrors.agreePrivacyPolicy}
              />
              &nbsp;
              <Grid
                container
                className={classes.privacyPolicyLink}
                onClick={() => setIsPrivacyPolicyDisplayed(true)}
              >
                privacy policy
              </Grid>
            </Grid>
          )}

          {bookingSettings.isCancellationBoxDisplay && (
            <Grid container className={classes.greyBox}>
              <Typography
                variant="subtitle1"
                className={classes.greyBoxTitle}
              >
                Cancellation policy
              </Typography>
              <Grid container className={classes.cancellationTextBox}>
                {bookingSettings.cancellationOption !== bookingCancellationOptions.anytime.option && (
                  <Grid item>
                    {cancellationOptionText(
                      bookingSettings.cancellationOption,
                      bookingSettings.formattedCancellationTime,
                    )}
                  </Grid>
                )}
                <Grid item>
                  {bookingSettings.additionalCancellationTerms}
                </Grid>
              </Grid>
              <Grid item className={classes.greyBoxAction}>
                <Checkbox
                  label="I agree"
                  checked={bookingOptions.agreeCancellationPolicy}
                  onChange={() => {
                    return handleChangeBookingOptions('agreeCancellationPolicy');
                  }}
                  error={bookingOptionErrors.agreeCancellationPolicy}
                />
              </Grid>
            </Grid>
          )}

          {bookingQuestion && isBookingQuestionRequired && (
            <Grid container className={classes.greyBox}>
              <Typography
                variant="subtitle1"
                className={classes.greyBoxTitle}
              >
                Important information required
              </Typography>
              <Grid item>{bookingQuestion}</Grid>
              <Grid item className={classes.greyBoxAction}>
                <Textarea
                  id="serviceBookingAnswer"
                  name="serviceBookingAnswer"
                  value={appointment.serviceBookingAnswer}
                  onChange={({target}) => {
                    return handleChangeAppointment(target.name, target.value);
                  }}
                  minRows="3"
                  className={classes.textarea}
                  rootComponentProps={{
                    InputProps: {
                      className: classes.whiteBoxArea,
                    },
                  }}
                  error={appointmentErrors.serviceBookingAnswer}
                />
              </Grid>
            </Grid>
          )}

          <Grid container className={classes.greyBox}>
            <Typography
              variant="subtitle1"
              className={classes.greyBoxTitle}
            >
              Note to Staff (optional)
            </Typography>
            <Grid item className={classes.greyBoxAction}>
              <Textarea
                id="notes"
                name="notes"
                value={appointment.notes}
                onChange={({target}) => {
                  return handleChangeAppointment(target.name, target.value);
                }}
                minRows="3"
                className={classes.textarea}
                rootComponentProps={{
                  InputProps: {
                    className: classes.whiteBoxArea,
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <CircularProgressWithBackdrop loading={isLoading}/>
      </main>

      <footer className={parentClasses.footer}>
        <GreenButton
          stretched
          variant="contained"
          size="large"
          onClick={handleCompliteBooking}
          className={parentClasses.mainButton}
        >
          {isPayWithCard ? 'Next' : 'Confirm'}
        </GreenButton>
        <Dialog open={isUnmatchedFieldDialogOpen} onClose={() => setIsUnmatchedFieldDialogOpen(false)}>
          <DialogTitle>Update profile?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Your profile on file has your <b><span style={{color: primaryColor}}>{FIELD_LABELS[unmatchedFieldName]}</span></b> as&nbsp;
              <b>{unmatchedFieldValue}</b> and you have entered <b>{client[unmatchedFieldName]}</b>. Would you like to update your profile or keep the same?
            </DialogContentText>
          </DialogContent>
          <div style={{display: 'flex', flexDirection: 'column', padding: '0 20px 10px'}}>
            <Button
              variant="outlined"
              fullWidth
              style={{marginBottom: '10px'}}
              onClick={useExistingValue}
              disabled={isNewValueBtnDisable}
            >
              Keep as {unmatchedFieldValue}
            </Button>
            <Button
              variant="outlined"
              fullWidth
              style={{marginBottom: '10px'}}
              onClick={useNewValue}
              disabled={isNewValueBtnDisable}
            >
              Change to {client[unmatchedFieldName]}
            </Button>
            {
              unmatchedFieldName === 'firstName'
                ? (
                  <Button
                    variant="outlined"
                    fullWidth
                    style={{marginBottom: '10px'}}
                    onClick={useNewPerson}
                    disabled={isNewValueBtnDisable}
                  >
                    I'm a New Person
                  </Button>
                )
                : null
            }
          </div>
        </Dialog>
      </footer>

      <Hidden>
        <CustomDialog
          fullWidth
          maxWidth="lg"
          open={isPrivacyPolicyDisplayed}
          onClose={() => setIsPrivacyPolicyDisplayed(false)}
          classes={{
            paper: parentClasses.paper,
          }}
        >
          <PrivacyPolicy
            onClose={() => setIsPrivacyPolicyDisplayed(false)}
            content={bookingSettings.privacyPolicy}
          />
        </CustomDialog>
      </Hidden>
      <Hidden mdUp>
        <CustomDialog
          fullScreen
          open={isPrivacyPolicyDisplayed}
          onClose={() => setIsPrivacyPolicyDisplayed(false)}
          classes={{
            paper: parentClasses.paper,
          }}
        >
          <PrivacyPolicy
            onClose={() => setIsPrivacyPolicyDisplayed(false)}
            content={bookingSettings.privacyPolicy}
          />
        </CustomDialog>
      </Hidden>
      <CustomDialog
        fullScreen
        open={isCreditCardRequired}
        onClose={creditCardDialogClose}
        classes={{
          paper: parentClasses.paper,
        }}
      >
        <CreditCardRequired
          title="Confirm your appointment with a card"
          pargraph="Our policy requires a credit card on file to confirm your appointment. Your payment details will be securely stored with Stripe. No charges will be made at this time."
          business={business}
          setCardRequired={setCardRequired}
          client={client}
          handleDisplayFlashMessage={props.handleDisplayFlashMessage}
          creditCardHandler={creditCardHandler}
          isLoading={isLoading}
        />
      </CustomDialog>
    </div>
  );
};

export default Client;
